import React, { useState } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import P90View from './P90View.jsx';

const SUB_TABS = [
  { value: 'p90', label: 'P90 Dealers with No Sales' },
];

export default function InsightsView({ month, snapshotDaysMap, handleDisableTab }) {
  const [subTab, setSubTab] = useState('p90');

  return (
    <Box>
      <Tabs
        value={subTab}
        onChange={(_, v) => setSubTab(v)}
        TabIndicatorProps={{ style: { backgroundColor: '#343c8c' } }}
        sx={{
          minHeight: 28,
          mb: 1,
          '& .MuiTab-root': {
            textTransform: 'none',
            fontWeight: 400,
            fontSize: '13px',
            px: 3,
            py: 0.5,
            minHeight: 28,
            color: '#444',
          },
          '& .Mui-selected': {
            color: '#215093',
            fontWeight: 700,
          },
        }}
      >
        {SUB_TABS.map((t) => (
          <Tab key={t.value} label={t.label} value={t.value} />
        ))}
      </Tabs>

      {subTab === 'p90' && (
        <P90View handleDisableTab={handleDisableTab} month={month} snapshotDaysMap={snapshotDaysMap} />
      )}
    </Box>
  );
}
